<template>
    <div class="invite-public-share" v-if="showPanel" style="display: block">
        <Panel v-bind="config" @share="handleShare" ref="panelRef" />
    </div>
    <div v-else style="display: none"></div>
</template>

<script >
import { use } from '@fegobull/webapi';
import { Channel, Panel } from '@futuweb/growth-share-panel';
import { computed, ref, useAttrs } from 'vue-demi';
import { EXPOSE_FEGO_METHOD } from '../common/constants';
import { Language, _lang, currentLanguage, watchLanguage } from '../common/lang';
import { appDataList, code, inviteLink } from '../common/payload';
import { shareReport } from '../common/report';
const __sfc_main = {};
__sfc_main.props = {
  // 语种
  language: {
    type: String,
    default: Language.EN
  },
  market: {
    type: String,
    default: ''
  },
  imageConfigs: {
    type: Array,
    default: () => []
  },
  descConfigs: {
    type: Array,
    default: () => []
  },
  channelConfigs: {
    type: Array,
    default: () => []
  },
  forceDisplay: {
    type: Boolean,
    default: false
  },
  displayMyCode: {
    type: Boolean,
    default: true
  },
  displayShareChannel: {
    type: Boolean,
    default: true
  },
  inviteTitle: {
    type: String,
    default: _lang('inviteTitle')
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useUser
  } = use;
  const panelRef = ref();
  // 注意：useAttrs 必须在 setup 上下文中调用一次后复用，不能在事件回调里直接调用（否则会出现 setupContext 为 null）
  const attrs = useAttrs();
  const reportAttrs = computed(() => ({
    element_id: attrs?.['data-id'] || '',
    element_name: attrs?.['data-name'] || ''
  }));
  const props = __props;
  watchLanguage(() => props.language);
  const config = computed(() => {
    const res = {
      forceDisplay: props.forceDisplay,
      displayMyCode: Number(props.displayMyCode),
      displayShareChannel: Number(props.displayShareChannel),
      language: currentLanguage.value,
      code: code.value,
      inviteLink: inviteLink.value,
      appDataList: appDataList.value,
      imageConfigs: props.imageConfigs,
      descConfigs: props.descConfigs,
      channelConfigs: props.channelConfigs,
      inviteTitle: props.inviteTitle
    };
    return res;
  });
  const showPanel = computed(() => {
    if (window.FEGOEditor) {
      return true;
    }
    const {
      isLogin
    } = useUser();
    return isLogin;
  });
  // 事件上报
  function handleShare(payload) {
    shareReport({
      channel: payload.channel,
      material_id: `${payload.imageConfig?.id || ''}`,
      string_id: `${payload.descConfig?.id || ''}`,
      user_home_market: props.market,
      report_attrs: reportAttrs.value
    });
  }
  return Object.assign({
    panelRef,
    config,
    showPanel,
    handleShare
  }, {
    [EXPOSE_FEGO_METHOD.SHOW_RENOTE_SHARE_POP]: () => {
      panelRef.value.displayChannelSharePop(Channel.XIAOHONGSHU);
    }
  });
};
__sfc_main.components = Object.assign({
  Panel
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.invite-public-share {
    height: auto !important;
}
</style>
